import {Booking} from '@shared/models/data-models/booking.model';

export class VisitListDay {

  date: Date;
  timeSlots: Booking[];
}
